function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var AssaultTemplate = require('./siege.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var AssaultOverlay = /*#__PURE__*/function () {
  function AssaultOverlay(app, mod) {
    _classCallCheck(this, AssaultOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(AssaultOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.pushHudUnderOverlay();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "renderPostAssault",
    value: function renderPostAssault() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.siege-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/siege.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Assault over in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "renderAssault",
    value: function renderAssault() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.siege-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/siege.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Assault in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "renderPreAssault",
    value: function renderPreAssault() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res, 1);
      var obj = document.querySelector('.siege-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/siege.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Assault imminent in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "assignHits",
    value: function assignHits() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = res.attacker_hits;
      if (faction === res.attacker_faction) {
        hits_to_assign = res.defender_hits;
      }
      this.assignHitsManually(res, faction, hits_to_assign);
    }
  }, {
    key: "assignHitsManually",
    value: function assignHitsManually() {
      var _this = this;
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var am_i_attacker = false;
      var am_i_defender = false;
      if (this.mod.game.player == this.mod.returnPlayerCommandingFaction(res.attacker_faction)) {
        am_i_attacker = true;
      }
      if (this.mod.game.player == this.mod.returnPlayerCommandingFaction(res.defender_faction)) {
        am_i_defender = true;
      }
      this.pushHudUnderOverlay();
      var side = '.attacker';
      if (this.mod.returnPlayerCommandingFaction(faction) != this.mod.returnPlayerCommandingFaction(res.attacker_faction)) {
        side = '.defender';
      }

      //
      // remove abstract entries
      //
      document.querySelectorAll(".siege-grid ".concat(side, " .siege-row")).forEach(function (el) {
        el.remove();
      });

      //
      // Attacker Units
      //
      if (side === '.attacker') {
        var faction_name = '';
        for (var i = 0; i < res.attacker_units_units.length; i++) {
          var roll = 'x';
          var unit_type = res.attacker_units_units[i].type;
          if (res.attacker_units_faction[i]) {
            faction_name = res.attacker_units_faction[i];
          }
          var assignable = '';
          if (am_i_attacker) {
            assignable = ' not-assignable';
          }
          if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(unit_type)) {
            if (am_i_attacker) {
              assignable = ' hits-assignable';
            }
          }
          if (res.attacker_units_destroyed.includes(i)) {
            assignable = 'destroyed';
            faction_name = 'destroyed';
          }
          var rrclass = '';
          var html = "\n\t\t\t                <div class=\"siege-row ".concat(assignable, "\" data-unit-type=\"").concat(unit_type, "\" data-faction=\"").concat(faction_name, "\">\n\t\t\t                        <div class=\"siege-unit\">").concat(unit_type, "<div class=\"siege-desc\">").concat(faction_name, "</div></div>\n\t\t\t                        <div class=\"siege-roll ").concat(rrclass, "\">").concat(roll, "</div>\n\t\t\t                </div>\n\t\t                ");
          this.app.browser.addElementToSelector(html, '.siege-grid .attacker');
        }
        //
        // Defender Units
        //
      } else {
        var _faction_name = '';
        for (var _i = 0; _i < res.defender_units_units.length; _i++) {
          var _roll = 'x';
          var _unit_type = res.defender_units_units[_i].type;
          if (res.defender_units_faction[_i]) {
            _faction_name = res.defender_units_units[_i].owner;
          }
          var _assignable = '';
          if (am_i_defender) {
            _assignable = ' not-assignable';
          }
          if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(_unit_type)) {
            if (am_i_defender) {
              _assignable = ' hits-assignable';
            }
          }
          if (res.defender_units_destroyed.includes(_i)) {
            _assignable = 'destroyed';
            _faction_name = 'destroyed';
          }
          var _rrclass = '';
          var _html = "\n\t\t\t                <div class=\"siege-row ".concat(_assignable, "\" data-unit-type=\"").concat(_unit_type, "\" data-faction=\"").concat(_faction_name, "\">\n\t\t\t                        <div class=\"siege-unit\">").concat(_unit_type, "<div class=\"siege-desc\">").concat(_faction_name, "</div></div>\n\t\t\t                        <div class=\"siege-roll ").concat(_rrclass, "\">").concat(_roll, "</div>\n\t\t\t                </div>\n\t\t               ");
          this.app.browser.addElementToSelector(_html, '.siege-grid .defender');
        }

        //
        // defender cavalry can have hits assigned
        //
        if (this.mod.game.spaces[res.spacekey].political == 'ottoman' || this.mod.game.spaces[res.spacekey].home == 'ottoman') {
          if (this.mod.game.spaces[res.spacekey].units['ottoman'].length > 0) {
            for (var z = 0; z < this.mod.game.spaces[res.spacekey].units['ottoman'].length; z++) {
              var u = this.mod.game.spaces[res.spacekey].units['ottoman'][z];
              if (u.type == 'cavalry') {
                var _html2 = "\n\t\t\t        \t\t\t        <div class=\"siege-row hits-assignable\" data-unit-type=\"cavalry\" data-faction=\"ottoman\">\n\t\t\t        \t\t\t                <div class=\"siege-unit\">cavalry<div class=\"siege-desc\">ottoman</div></div>\n\t\t\t                \t\t\t        <div class=\"siege-roll\">0</div>\n\t\t\t               \t\t\t\t</div>\n\t\t               \t\t\t\t";
                this.app.browser.addElementToSelector(_html2, '.siege-grid .defender');
              }
            }
          }
        }
      }
      var hits_assignable = 0;
      var hits_assigned = 0;
      var his_self = this.mod;
      this.updateInstructions("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
      this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
      document.querySelectorAll('.not-assignable').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.hits-assignable').forEach(function (el) {
        var obj = el.querySelector('.siege-desc');
        if (obj) {
          var factionspace = obj.innerHTML;
          var can_i_kill_this_guy = false;
          if (factionspace === faction || his_self.returnAllyOfMinorPower(factionspace) === faction) {
            can_i_kill_this_guy = true;
          }
          if (can_i_kill_this_guy) {
            if (factionspace) {
              el.querySelector('.siege-desc').innerHTML += ' (click to assign hit)';
            }
            el.classList.add('hits-assignable-hover-effect');
            hits_assignable++;
            el.onclick = function (e) {
              hits_assigned++;
              var hits_left = hits_to_assign - hits_assigned;
              document.querySelectorAll('hits_to_assign').forEach(function (el) {
                el.innerHTML = hits_left;
              });
              var unit_type = el.getAttribute('data-unit-type');
              var faction = el.getAttribute('data-faction');
              var spacekey = res.spacekey;
              el.remove();
              _this.mod.addMove('siege_destroy_unit\t' + faction + '\t' + spacekey + '\t' + unit_type);
              if (hits_assigned == hits_to_assign || hits_assigned >= hits_assignable) {
                document.querySelectorAll('.hits-assignable').forEach(function (el) {
                  el.onclick = function (e) {};
                });
                _this.mod.endTurn();
                _this.pushHudUnderOverlay();
                _this.overlay.hide();
              }
            };
          }
        }
      });
      if (faction != '') {
        if (this.mod.game.player == this.mod.returnPlayerOfFaction(faction)) {
          this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
        } else {
          this.updateInstructions(this.mod.returnFactionName(faction) + ' Assigning Hits');
        }
      } else {
        this.updateInstructions('Assigning Hits');
      }
    }
  }, {
    key: "attackersWin",
    value: function attackersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.siege-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/siege.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Attackers Win - Close to Continue');
    }
  }, {
    key: "defendersWin",
    value: function defendersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.siege-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/siege.png)';
      obj.style.backgroundSize = 'cover';
      this.updateInstructions('Defenders Win - Close to Continue');
    }
  }, {
    key: "render",
    value: function render() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pre_battle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var am_i_attacker = false;
      var am_i_defender = false;
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.attacker_faction)) {
        am_i_attacker = true;
      }
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.defender_faction)) {
        am_i_defender = true;
      }
      this.visible = true;
      this.overlay.show(AssaultTemplate());
      this.updateInstructions('Assault in ' + this.mod.returnSpaceName(res.spacekey));
      if (pre_battle == 1) {
        res.attacker_modified_rolls = res.attacker_results;
      }
      if (pre_battle == 1) {
        res.defender_modified_rolls = res.defender_results;
      }
      if (res.attacker_modified_rolls) {
        var faction_name = '';
        for (var i = 0; i < res.attacker_modified_rolls.length; i++) {
          var roll = res.attacker_modified_rolls[i];
          var unit_type = 'assault';
          if (res.attacker_units_faction[i]) {
            faction_name = res.attacker_units_faction[i];
          }
          var rrclass = '';
          if (roll >= 5) {
            rrclass = 'hit';
          }
          if (pre_battle) {
            roll = '?';
            rrclass = '';
          }
          var html = "\n                <div class=\"siege-row\" data-unit-type=\"".concat(unit_type, "\" data-faction=\"").concat(faction_name, "\">\n                \t<div class=\"siege-unit\">").concat(unit_type, "<div class=\"siege-desc\">").concat(faction_name, "</div></div>\n                \t<div class=\"siege-roll ").concat(rrclass, "\">").concat(roll, "</div>\n                </div>\n              ");
          this.app.browser.addElementToSelector(html, '.siege-grid .attacker');
        }
      }
      if (res.defender_modified_rolls) {
        var _faction_name2 = '';
        for (var _i2 = 0; _i2 < res.defender_modified_rolls.length; _i2++) {
          var _roll2 = res.defender_modified_rolls[_i2];
          var _unit_type2 = 'assault';
          if (res.defender_units_faction[_i2]) {
            _faction_name2 = res.defender_units_faction[_i2];
          }
          var _rrclass2 = '';
          if (_roll2 >= 5) {
            _rrclass2 = 'hit';
          }
          if (pre_battle) {
            _roll2 = '?';
            _rrclass2 = '';
          }
          var _html3 = "\n                <div class=\"siege-row\" data-unit-type=\"".concat(_unit_type2, "\" data-faction=\"").concat(_faction_name2, "\">\n                \t<div class=\"siege-unit\">").concat(_unit_type2, "<div class=\"siege-desc\">").concat(_faction_name2, "</div></div>\n                \t<div class=\"siege-roll ").concat(_rrclass2, "\">").concat(_roll2, "</div>\n                </div>\n              ");
          this.app.browser.addElementToSelector(_html3, '.siege-grid .defender');
        }
      }
      this.attachEvents();
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var help = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var x = document.querySelector('.siege-overlay .help');
      if (x) {
        x.innerHTML = help;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "showAssaultResults",
    value: function showAssaultResults(obj) {}
  }]);
}();
module.exports = AssaultOverlay;